var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RowFormWrapper',{attrs:{"title":_vm.column.title,"mandatory":_vm.column.mandatory,"description":_vm.column.description}},[_c('TiptapMenuBar',{attrs:{"value":_vm.localValue,"text-length-limit":_vm.getTextLimit},on:{"update:value":function($event){_vm.localValue=$event},"input":_vm.updateText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }